import axios from 'axios';

const URL_API_NOTAS = process.env.VUE_APP_URL_API_NOTAS;

export class NotasApiService {
  /**
   * Devuelve las notas disponibles
   * @return Hashmap[]
   */
  getAllNotas(opuid) {
    let config = {
      headers: {'Authorization': localStorage.getItem("token"), 'instalacion' : localStorage.getItem("instalacion")}
    };
    const url = `${URL_API_NOTAS}getAllNotas/${opuid}`;
    return axios
      .get(url,config)
      .then(function(response) {
        return response.data;
       
      })
      .catch(function(error) {
        if (error.response.status===401 || error.response.status===403){
          window.location.href = process.env.VUE_APP_PATH + '#/logout'
        }
        throw error;
      });
  }
  createNota(nota) {
    let config = {
      headers: {'Authorization': localStorage.getItem("token"), 'instalacion' : localStorage.getItem("instalacion")}
    };
    const url = `${URL_API_NOTAS}createNota`;
    return axios
      .post(url, nota, config)
      .then(function(response) {
        return response.data;
      })
      .catch(function(error) {
        if (error.response.status===401 || error.response.status===403){
          window.location.href = process.env.VUE_APP_PATH + '#/logout'
        }
        throw error;
      });
  }
  deleteNota(nota) {
    let config = {
      headers: {'Authorization': localStorage.getItem("token"), 'instalacion' : localStorage.getItem("instalacion")}
    };
    const url = `${URL_API_NOTAS}deleteNota`;
    return axios
      .post(url, nota, config)
      .then(function(response) {
        return response.data;
      })
      .catch(function(error) {
        if (error.response.status===401 || error.response.status===403){
          window.location.href = process.env.VUE_APP_PATH + '#/logout'
        }
        throw error;
      });
  }
  updateNota(nota){
    let config = {
      headers: {'Authorization': localStorage.getItem("token"), 'instalacion' : localStorage.getItem("instalacion")}
    };
    const url = `${URL_API_NOTAS}updateNota`;
    return axios
      .post(url, nota, config)
      .then(function(response) {
        return response.data;
      })
      .catch(function(error) {
        if (error.response.status===401 || error.response.status===403){
          window.location.href = process.env.VUE_APP_PATH + '#/logout'
        }
        throw error;
      });
  }
}